import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { NotificationType } from 'src/app/models';

@Injectable({
    providedIn: 'root',
})
export class TopNotificationService {
    private notificationSubject = new Subject<any>();
    private notificationTimeOut!: any;

  showNotification(message: string, type: NotificationType) {
        this.notificationSubject.next({ message: message, type: type });

        clearTimeout(this.notificationTimeOut);

        if (type === NotificationType.Success || type === NotificationType.Info) {
            this.notificationTimeOut = setTimeout(() => {
                this.hideNotification();
            }, environment.notificationDisappearInMilliseconds);
        }
    }

    hideNotification() {
        this.notificationSubject.next(null);
    }

    getNotification() {
        return this.notificationSubject.asObservable();
    }
}
